/* import __COLOCATED_TEMPLATE__ from './category-title-link.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import TEMPLATE from "./category-title-link.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({
  tagName: "h3",
  // icon name defined here so it can be easily overridden in theme components
  lockIcon: "lock"
}));